import { Component } from '@theme/component';

class AtelierFooter extends Component {
  #listeners;
  #wide;
  connectedCallback() {
    super.connectedCallback();
    this.#listeners?.abort(); this.#listeners = new AbortController();
    const options = {signal:this.#listeners.signal};
    this.#wide = matchMedia('(min-width: 768px)');
    this.#wide.addEventListener('change',this.#layout,options);
    this.addEventListener('click',event=>{
      if (this.#wide.matches && event.target.closest('[data-atelier-footer-column] summary')) event.preventDefault();
    },options);
    this.#layout();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#listeners?.abort(); }
  #layout = () => {
    this.querySelectorAll('[data-atelier-footer-column]').forEach(column=>{
      column.open = this.#wide.matches;
      column.querySelector('summary').tabIndex = this.#wide.matches ? -1 : 0;
    });
  };
}
if (!customElements.get('fivepoint-atelier-footer')) customElements.define('fivepoint-atelier-footer',AtelierFooter);
